import { ChargeItemResMock } from '../types/chargeItem.type'
import { DrugSearchResMock, SearchData } from '../types/drug.type'
import { GeneralResMock } from '../types/general.type'
import { ProductInventoryResMock } from '../types/inventory.type'
import { LaboratoryResMock } from '../types/laboratory.type'
import { MedicationDataMock, MedicationIncluded } from '../types/medication.type'
import { ProceedResMock } from '../types/proceed.type'
import { RoomIncluded, RoomResMock } from '../types/room.type'
import { capitalizeDrugName, getError } from '../utils'
import AXIOS_INSTANCE from './axiosInstance'

// type DrugaSearchDataMock = {

//     "data": [
//         {
//             "id": "inventory_2",
//             "name": "AMLODIPINE 10MG",
//             "form": "Tablet",
//             "available_strengths": [
//                 {
//                     "api_name": "amlodipine 10mg",
//                     "strength": "10 mg",
//                     "earliest_expiry_date": "2027-02-05"
//                 }
//             ]
//         }
//     ]

// }
export const drugAction = async (query?: string): Promise<{ label: string; value: string }[]> => {
  let drugList: { label: string; value: string }[] = []
  try {
    const { data } = await AXIOS_INSTANCE.get<GeneralResMock<import('../types/drug.type').DrugResMock[]>>('drugs', {
      params: { ...(query && { query: encodeURIComponent(query) }), sort_by: 'name', sort_dir: 'asc' }
    })
    drugList = (data.data || [])?.map(drug => ({
      label: capitalizeDrugName(drug.attributes?.name),
      value: drug.attributes?.name
    }))

    return drugList
  } catch (error: any) {
    getError(error)
  }
  return drugList
}

export const ProductInventoryAction = async (query?: string): Promise<{ label: string; value: string }[]> => {
  let productInventoryList: { label: string; value: string }[] = []
  try {
    const { data } = await AXIOS_INSTANCE.get<GeneralResMock<ProductInventoryResMock[]>>('product_inventories', {
      params: { ...(query && { query: encodeURIComponent(query) }) }
    })
    productInventoryList = (data.data || [])?.map(productInventory => ({
      label: capitalizeDrugName(productInventory.attributes?.drug_name),
      value: productInventory?.id ?? ''
    }))

    return productInventoryList
  } catch (error: any) {
    getError(error)
  }
  return productInventoryList
}

export const labAction = async (query?: string): Promise<{ label: string; value: string }[]> => {
  let labList: { label: string; value: string }[] = []
  try {
    const { data } = await AXIOS_INSTANCE.get<GeneralResMock<LaboratoryResMock[]>>('labs', {
      params: { ...(query && { query: encodeURIComponent(query) }) }
    })
    labList = (data.data || [])?.map(lab => ({
      label: lab.attributes?.name ?? '',
      value: lab?.id
    }))

    return labList
  } catch (error: any) {
    getError(error)
  }
  return labList
}

export const procedureAction = async (query?: string): Promise<{ label: string; value: string }[]> => {
  let procedureListData: { label: string; value: string }[] = []
  try {
    const { data } = await AXIOS_INSTANCE.get<GeneralResMock<ProceedResMock[]>>('procedures', {
      params: { ...(query && { query: encodeURIComponent(query) }) }
    })
    procedureListData = (data.data || [])?.map(procedure => ({
      label: procedure.attributes?.name ?? '',
      value: procedure?.id
    }))

    return procedureListData
  } catch (error: any) {
    getError(error)
  }
  return procedureListData
}

export const imagingAction = async (query?: string): Promise<{ label: string; value: string }[]> => {
  let imagingListData: { label: string; value: string }[] = []
  try {
    const { data } = await AXIOS_INSTANCE.get<GeneralResMock<LaboratoryResMock[]>>('imagings', {
      params: { ...(query && { query: encodeURIComponent(query) }) }
    })
    imagingListData = (data.data || []).map(imaging => ({
      label: imaging.attributes?.study_type ?? '',
      value: imaging?.id
    }))

    return imagingListData
  } catch (error: any) {
    getError(error)
  }
  return imagingListData
}

export const roomAction = async (query?: string): Promise<{ label: string; value: string }[]> => {
  let roomListData: { label: string; value: string }[] = []
  try {
    const { data } = await AXIOS_INSTANCE.get<GeneralResMock<RoomResMock[], RoomIncluded[]>>(`rooms`, {
      params: { ...(query && { query: encodeURIComponent(query) }) }
    })
    roomListData = (data.data || []).map(room => ({
      label: `${room.attributes?.room_number} - ${room.attributes?.room_type}`,
      value: room?.id
    }))
  } catch (error: any) {
    getError(error)
  }
  return roomListData
}

export const chargeItemAction = async (query?: string): Promise<{ label: string; value: string }[]> => {
  let chargeItemList: { label: string; value: string }[] = []
  try {
    const { data } = await AXIOS_INSTANCE.get<GeneralResMock<ChargeItemResMock[]>>('charge_items', {
      params: { ...(query && { query: encodeURIComponent(query) }) }
    })
    chargeItemList = (data.data || [])?.map(chargeItem => ({
      label: chargeItem.attributes?.name ?? '',
      value: chargeItem?.id
    }))

    return chargeItemList
  } catch (error: any) {
    getError(error)
  }
  return chargeItemList
}

export const drugSearchAction = async (query?: string, form?: string): Promise<{ label: string; value: string }[]> => {
  let strengthList: { label: string; value: string }[] = []
  try {
    const endpoint = 'drugs/search'
    const params = {
      ...(query && { query: encodeURIComponent(query) }),
      ...(form && { form: encodeURIComponent(form) })
    }
    const { data } = await AXIOS_INSTANCE.get<SearchData>(endpoint, { params })
    strengthList = (data?.data || [])?.map(drug => ({
      label: drug.name ?? '',
      value: drug.name ?? ''
    }))
    return strengthList
  } catch (error: any) {
    getError(error)
  }
  return strengthList
}

/**
 * The signed-in prescriber's most recent order of this drug, or null when they have never ordered it.
 * The medication is slim: attributes nf_drug_name, form, strength, route, dose_quantity, dose_unit,
 * custom_frequency, once, start_at, end_at, created_at; relationship medication_frequency; `included`
 * holds only that medication_frequency (name, code). Errors are left to the caller.
 */
export const fetchLastMedicationOrder = async (
  nfDrugName: string
): Promise<{ medication: MedicationDataMock; included: MedicationIncluded[] } | null> => {
  const { data } = await AXIOS_INSTANCE.get<GeneralResMock<MedicationDataMock | null, MedicationIncluded[]>>(
    'medications/last_order',
    { params: { nf_drug_name: nfDrugName }, skipNavigationFeedback: true }
  )
  if (!data?.data) return null
  return { included: data.included ?? [], medication: data.data }
}

/** Drug catalog search (same endpoint as useDrugs' drugSearch). Errors are left to the caller. */
export const searchDrugCatalog = async (query: string, form?: string): Promise<DrugSearchResMock[]> => {
  const { data } = await AXIOS_INSTANCE.get<SearchData>('drugs/search', {
    params: { ...(form && { form }), query },
    skipNavigationFeedback: true
  })
  return data?.data ?? []
}
